module.exports = __webpack_public_path__ + "img/181218_Wiebke_KalenderEntwurf_Mockup_01_cl.8b53040e.jpg";